const toBoolean = (value) => {
  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase();
    if (normalized === 'true') return true;
    if (normalized === 'false') return false;
  }
  return Boolean(value);
};

const normalizeAccountFlags = (account = {}) => {
  const normalized = { ...account };
  const rawIsPublicUser = normalized.isPublicUser !== undefined
    ? normalized.isPublicUser
    : normalized.IsPublicUser !== undefined
      ? normalized.IsPublicUser
      : false;

  normalized.isPublicUser = toBoolean(rawIsPublicUser);
  return normalized;
};

module.exports = {
  toBoolean,
  normalizeAccountFlags,
};
